export enum EEventType {
  PARTY = 'PARTY',
  NIGHT_PARTY = 'NIGHT_PARTY',
}



export default EEventType;
